import React from "react";
import { motion } from "framer-motion";
import { FiCheckCircle } from "react-icons/fi";

export default function Features() {
  return (
    <section className="w-full bg-[#f2f4ef] py-24 md:py-32 px-4 md:px-8 relative overflow-hidden">
      <link href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;700&display=swap" rel="stylesheet" />
      <div className="max-w-[1240px] mx-auto flex flex-col items-center">
        <div className="relative mb-20 text-center z-10 w-full flex flex-col items-center">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="text-[72px] font-['Anton',sans-serif] font-normal text-black uppercase leading-[80px] max-w-[1000px] relative z-10"
          >
            BUILT FOR SPEED,<br /> SECURITY,
            <span className="relative inline-block">
              <img src="https://cdn.jiro.build/Random/economy-concept-with-copy-space%201.png" alt="Dollar bill" className="absolute top-1/2 left-[10%] -translate-x-1/2 -translate-y-1/2 w-[60px] md:w-[100px] lg:w-[140px] rotate-[22deg] z-20 pointer-events-none drop-shadow-[0_14px_24px_rgba(0,0,0,0.15)]" style={{ marginTop: '-10px' }} />
              AND
            </span> SCALE
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full relative z-20">
          <motion.div
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="bg-white rounded-[32px] px-8 pb-8 pt-[20px] md:px-10 md:pb-10 md:pt-[20px] flex flex-col items-center h-full text-center shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:-translate-y-2 transition-transform duration-300">
              <div className="h-[180px] w-full flex items-center justify-center mb-6">
                <motion.img
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.6, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
                  src="https://cdn.jiro.build/Random/Receive%20money%20fast.png" alt="Receive money fast" className="max-w-full max-h-full object-contain mix-blend-multiply" />
              </div>
              <h3 className="text-[28px] font-bold text-[#0D0D0D] mb-4 leading-[1.2]">Receive money fast</h3>
              <p className="text-[17px] text-[#4B4B4B] leading-[1.5] mb-8 font-medium">
                Get paid easily in other currencies with global account details.
              </p>
              <div className="flex items-center gap-2 mb-10 text-[15px] font-bold text-[#0D211D]">
                <FiCheckCircle className="w-5 h-5 fill-[#0D211D] text-white" /> 22 currencies
              </div>
              <div className="mt-auto w-full">
                <button className="w-full py-[14px] px-[24px] border border-[#0D0D0D] text-[#0D0D0D] font-sans font-medium text-[16px] rounded-full hover:bg-[#0D0D0D] hover:text-white transition-colors">
                  Explore getting paid
                </button>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="bg-white rounded-[32px] px-8 pb-8 pt-[20px] md:px-10 md:pb-10 md:pt-[20px] flex flex-col items-center h-full text-center shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:-translate-y-2 transition-transform duration-300">
              <div className="h-[180px] w-full flex items-center justify-center mb-6">
                <motion.img
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.6, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
                  src="https://cdn.jiro.build/Random/Save%20on%20spending%20abroad.png" alt="Save on spending abroad" className="max-w-[120%] h-auto object-contain mix-blend-multiply ml-[1.14px]" />
              </div>
              <h3 className="text-[28px] font-bold text-[#0D0D0D] mb-4 leading-[1.2]">Save on spending abroad</h3>
              <p className="text-[17px] text-[#4B4B4B] leading-[1.5] mb-8 font-medium">
                Pay and withdraw cash worldwide without any hidden fees or markups.
              </p>
              <div className="flex items-center gap-2 mb-10 text-[15px] font-bold text-[#0D211D]">
                <FiCheckCircle className="w-5 h-5 fill-[#0D211D] text-white" /> 215 countries and territories
              </div>
              <div className="mt-auto w-full">
                <button className="w-full py-[14px] px-[24px] border border-[#0D0D0D] text-[#0D0D0D] font-sans font-medium text-[16px] rounded-full hover:bg-[#0D0D0D] hover:text-white transition-colors">
                  Learn about Wise cards
                </button>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.7, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="bg-white rounded-[32px] px-8 pb-8 pt-[20px] md:px-10 md:pb-10 md:pt-[20px] flex flex-col items-center h-full text-center shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:-translate-y-2 transition-transform duration-300">
              <div className="h-[180px] w-full flex items-center justify-center mb-6">
                <motion.img
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 0.6, delay: 0.7, ease: [0.16, 1, 0.3, 1] }}
                  src="https://cdn.jiro.build/Random/Receive%20interest_.png" alt="Receive interest*" className="max-w-full max-h-full object-contain mix-blend-multiply" />
              </div>
              <h3 className="text-[28px] font-bold text-[#0D0D0D] mb-4 leading-[1.2]">Receive interest*</h3>
              <p className="text-[17px] text-[#4B4B4B] leading-[1.5] mb-8 font-medium">
                Opt in and get passthrough FDIC insurance up to $250,000 through our Program Bank.² ³
              </p>
              <div className="flex items-center gap-2 mb-10 text-[15px] font-bold text-[#0D211D]">
                <FiCheckCircle className="w-5 h-5 fill-[#0D211D] text-white" /> USD, GBP and EUR
              </div>
              <div className="mt-auto w-full">
                <button className="w-full py-[14px] px-[24px] border border-[#0D0D0D] text-[#0D0D0D] font-sans font-medium text-[16px] rounded-full hover:bg-[#0D0D0D] hover:text-white transition-colors">
                  See our interest feature
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}